module.exports = __webpack_public_path__ + "static/img/3-2.20a08130.png";